<h2 mat-dialog-title>Select File</h2>
<mat-dialog-content>
  <div class="upload-container">
    <input
      type="file"
      (change)="onFileSelected($event)"
      class="file-input"
    />

    <!-- Validation message -->
    <p *ngIf="validationMessage" class="error-message">
      {{ validationMessage }}
    </p>

    <p *ngIf="selectedFile">{{ selectedFile.name }}</p>
    <p *ngIf="!selectedFile && !validationMessage" class="placeholder">
      No file chosen
    </p>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button class="reset" (click)="close()">Cancel</button>
  <button class="btn" (click)="confirmUpload()" [disabled]="!selectedFile">
    Upload
  </button>
</mat-dialog-actions>
